import React from "react";
import { Link } from "react-router-dom";
import { Mail, Code } from "lucide-react";
import { GithubIcon, LinkedinIcon } from "./icons";
import INFO from "../../data/user";
import "./styles/footer.css";

const Footer = () => {
	const currentYear = new Date().getFullYear();

	return (
		<footer className="footer">
			<div className="footer-content">
				<div className="footer-brand">
					<span className="footer-brand-title">{INFO.main.name}</span>
					<span className="footer-brand-subtitle">
						{INFO.main.role} • {INFO.main.location}
					</span>
				</div>

				<div className="footer-links">
					<ul className="footer-nav-link-list">
						<li className="footer-nav-link-item">
							<Link to="/">Home</Link>
						</li>
						<li className="footer-nav-link-item">
							<Link to="/about">About</Link>
						</li>
						<li className="footer-nav-link-item">
							<Link to="/projects">Projects</Link>
						</li>
						<li className="footer-nav-link-item">
							<Link to="/articles">Articles</Link>
						</li>
						<li className="footer-nav-link-item">
							<Link to="/contact">Contact</Link>
						</li>
					</ul>
				</div>

				<div className="footer-socials">
					<a
						href={INFO.socials.github}
						target="_blank"
						rel="noreferrer"
						className="footer-social-icon"
						aria-label="GitHub Profile"
					>
						<GithubIcon size={18} />
					</a>
					<a
						href={INFO.socials.linkedin}
						target="_blank"
						rel="noreferrer"
						className="footer-social-icon"
						aria-label="LinkedIn Profile"
					>
						<LinkedinIcon size={18} />
					</a>
					<a
						href={INFO.socials.leetcode}
						target="_blank"
						rel="noreferrer"
						className="footer-social-icon"
						aria-label="LeetCode Profile"
					>
						<Code size={18} />
					</a>
					<a
						href={`mailto:${INFO.main.email}`}
						className="footer-social-icon"
						aria-label="Email Contact"
					>
						<Mail size={18} />
					</a>
				</div>
			</div>

			<div className="footer-credits">
				<div>© {currentYear} {INFO.main.name}. All Rights Reserved.</div>
				<div className="font-mono">Built with React & Spring Boot Mindset</div>
			</div>
		</footer>
	);
};

export default Footer;
